import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/views/index'),
      name: 'index',
      meta: {name: '首页'},
      redirect: {name: 'home'},
      children: [
        {
          path: '/',
          component: () => import('@/views/home'),
          name: 'index',
          meta: {name: '首页'},
        },
        {
          path: '/news',
          component: () => import('@/views/news/list'),
          name: 'newsList',
          meta: {name: '新闻动态'},
        },
        {
          path: '/news/detail',
          component: () => import('@/views/news/detail'),
          name: 'newsDetail',
          meta: {name: '新闻动态详细'},
        },
        {
          path: '/help',
          component: () => import('@/views/help/detail'),
          name: 'helpDetail',
          meta: {name: '帮助中心'},
        },
        {
          path: '/contact',
          component: () => import('@/views/contact/detail'),
          name: 'contact',
          meta: {name: '联系我们'},
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

//路由跳转时，取消当前路由中的请求
router.beforeEach((to, from, next) => {
  store.state._axiosPromiseCancel.forEach( e => {
     e && e()
  })
  store.commit('SET_AXIOSPROMISECANCEL', [])
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js